import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import Note from '../components/Note'
import NoteModal from '../components/NoteModal'
import { withStyles } from '@material-ui/core/styles'
import { getPatientNotes } from '../api'
import { orderByDate } from '../utils'

const styles = theme => ({
  page: {
    height: 'calc(100% - 90px)',
    width: '100%',
    overflow: 'scroll'
  },
  header: {
    fontSize: '1.5rem',
  },
  divider: {
    margin: '0 30px'
  },
  flex: {
    margin: 30,
    display: 'flex',
    justifyContent: 'space-between'
  }
})

class Notes extends Component {
  constructor (props) {
    super(props)

    this.state = {
      notes: [],
      modalOpen: false
    }
  }

  componentDidMount () {
    const { id } = this.props.patient
    getPatientNotes(id).then(response => this.setState({ notes: orderByDate(response, 'time').reverse()}))
  }

  render() {
    const { classes, patient } = this.props
    const { notes } = this.state

    if (!patient) return <div/>
    return (
      <div className={classes.page}>
        <NoteModal
          patient={patient}
          open={this.state.modalOpen}
          onClose={e => this.setState({modalOpen: false})}
          updateNotes={note => this.setState({notes: [note].concat(this.state.notes)})}
        />
        <div className={classes.flex}>
          <Typography className={classes.header}>Notes</Typography>
          <Button onClick={e => this.setState({modalOpen: true})} variant="contained" color="primary">
            Add New Note
          </Button>
        </div>
        <Divider className={classes.divider} />
        { notes.map(note => <Note note={note} />) }
      </div>
    )
  }
}

export default withStyles(styles)(Notes)



// WEBPACK FOOTER //
// ./src/pages/Notes.js